import { connectRealtime } from '@/lib/api-client';
import type { Socket } from 'socket.io-client';
import { tokenStore } from './api';

let socket: Socket | null = null;
let connectedWith: string | null = null;

/**
 * One shared socket per tab — components subscribe, they never reconnect.
 *
 * The gateway authenticates the handshake, so the socket is rebuilt
 * whenever the credential changes. A guest opens its session *after* the first
 * render, so a socket created before the scan would otherwise stay anonymous
 * and be disconnected as unauthorized.
 */
export function getSocket(rooms: string[] = []): Socket {
  const token = (tokenStore.get() as { accessToken?: string } | null)?.accessToken ?? null;

  if (socket && connectedWith !== token) disconnectSocket();

  if (!socket) {
    connectedWith = token;
    socket = connectRealtime({
      baseURL: import.meta.env.VITE_REALTIME_URL ?? 'http://localhost:4000',
      token: token ?? undefined,
      rooms,
    });
    // A guest may only join its own session and its own orders' rooms; the gateway
    // answers a refusal rather than dropping it silently, so surface it.
    socket.on('join:denied', (denied) => console.warn('realtime rooms denied', denied));
  } else if (rooms.length) {
    socket.emit('join', { rooms });
  }
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
  connectedWith = null;
}
